import { render, staticRenderFns } from "./SelectOrderHeaders.vue?vue&type=template&id=253242f6&scoped=true&"
import script from "./SelectOrderHeaders.vue?vue&type=script&lang=js&"
export * from "./SelectOrderHeaders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253242f6",
  null
  
)

export default component.exports